import { render, staticRenderFns } from "./Devolution.vue?vue&type=template&id=4c80b6a8"
import script from "./Devolution.vue?vue&type=script&lang=js"
export * from "./Devolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports